import { ReactElement } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { regionStore } from '../../store/jotai/store';
import { newVersionAvailableAtom } from '../../store/jotai/atoms/app-version.atom';
import './NewVersionPrompt.scss';

/**
 * Offers a reload when a newer build is being served — see
 * `services/version-service`. The reload is the user's call: a silent swap could
 * land in the middle of a checkout or a half-filled form.
 */
export const NewVersionPrompt = (): ReactElement | null => {
  const { t } = useTranslation();
  const newVersionAvailable = useAtomValue(newVersionAvailableAtom, { store: regionStore });

  if (!newVersionAvailable) {
    return null;
  }

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      className='new-version-prompt'>
      <Alert
        severity='info'
        className='new-version-prompt__alert'
        action={
          <Button color='inherit' size='small' onClick={() => window.location.reload()}>
            {t('appVersion.reload')}
          </Button>
        }>
        {t('appVersion.newVersionAvailable')}
      </Alert>
    </Snackbar>
  );
};
